// extracted by mini-css-extract-plugin
export default {"cooldownContainer":"styles_cooldownContainer__jj6sz"};